import React from 'react';
import { Button, Spacer } from '@chakra-ui/react';
import { useQuery } from 'react-query';
import { Context } from '../../App';
import { PropertyKey } from '../../model/property';
import { getPropertyKeys } from '../../api/property-key-controller';
import { QueryKeys } from '../../api/base/react-query';
import Table, { TableProps } from '../../base-components/Table';
import EditorParent from '@/base-components/EditorParent';
import { RoutePath, SPACING } from '@/generic/config';
import { useNavigate } from 'react-router-dom';

const PropertySearchPage: React.FC = () => {
    const { translations } = React.useContext(Context);
    const tm = translations.model.propertyKey;
    const navigate = useNavigate();

    const { data: propertyKeys = [], isLoading } = useQuery(QueryKeys.propertyKeys, () => getPropertyKeys());

    const tableProps: TableProps<PropertyKey> = {
        columns: [
            { title: tm.objectType, scale: 1, getter: (r) => r.objectType },
            { title: tm.key, scale: 2, getter: (r) => r.key },
            { title: tm.propertyType, scale: 1, getter: (r) => r.propertyType },
        ],
        rows: propertyKeys,
        isLoading,
        href: (row) => `${RoutePath.Properties}/${row.id}`,
    };

    return (
        <EditorParent title={tm.search.title}>
            <Button my={SPACING} onClick={() => navigate(`${RoutePath.Properties}/new`)}>{translations.common.registerNew}</Button>
            <Table tableProps={tableProps} />
        </EditorParent>
    );
};

export default PropertySearchPage;
